import LySelect from './src/index.vue'

LySelect.install = function (Vue) {
    Vue.component(LySelect.name, LySelect)
}

export default LySelect



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/select/index.js
// module id = null
// module chunks = 